import styled from "styled-components";

export const EulaAgreementContent = styled.div`
    width: 100%;
    max-height: 600px;
    padding: 16px 24px;
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
    overflow-y: scroll;
`;